// extracted by mini-css-extract-plugin
export default {"switch":"Toggle_switch__6nw-v","slider":"Toggle_slider__0azoT","container":"Toggle_container__Ge6zy","round":"Toggle_round__9gMWA"};